import { useCallback, useSyncExternalStore } from 'react';
import { can as canWith, canAny as canAnyWith, CapabilityState, getCapabilityState, subscribeCapabilities } from '../../library/Core/Capabilities';

/** The capability store as React state: components re-render when the capabilities load or change. */
export const useCapabilityState = (): CapabilityState => useSyncExternalStore(subscribeCapabilities, getCapabilityState);

/** useCan('alumni.directory.view') or useCan(['a.b.c', 'a.b.d']) (any of). */
export const useCan = (capability: string | string[]): boolean => {
    const current = useCapabilityState();
    return Array.isArray(capability) ? canAnyWith(capability, current) : canWith(capability, current);
};

/** For code that checks several keys: const { can, canAny, loaded } = useCapabilities(). */
export const useCapabilities = () => {
    const current = useCapabilityState();
    const can = useCallback((key: string) => canWith(key, current), [current]);
    const canAny = useCallback((keys: string[]) => canAnyWith(keys, current), [current]);
    return {
        can,
        canAny,
        loaded: current.loaded,
        error: current.error,
        wildcard: current.wildcard,
        roleCodes: current.roleCodes,
        loginMode: current.loginMode,
    };
};

export default useCan;
